import Phaser from 'phaser';

export default class CurColorDisplay extends Phaser.GameObjects.Container {

  constructor (scene, size) {
    super(scene);

    this.bgShape = null;
    this.colorShape = null;
    this.displaySize = null;

    this.displaySize = size;

    this.bgShape = this.scene.add.rectangle(0, 0, this.displaySize,this.displaySize, 0x918C93, 1).setOrigin(0)
      .setStrokeStyle(1, 0xffffff, 1);
    this.add(this.bgShape);

    this.colorShape = this.scene.add.rectangle(4,4,this.displaySize - 8,this.displaySize - 8).setOrigin(0);
    this.add(this.colorShape);

  };

  showColor(newColor) {
    this.colorShape.setFillStyle(newColor, 1);
  };
}
